import clsx from "clsx";
import * as React from "react";
import { ButtonKind, SpsIcon } from "@spscommerce/ds-shared";

import * as PropTypes from "../prop-types";
import { SpsButton } from "../button/SpsButton";
import { I18nContext } from "../i18n";

const propsDoc = {
    percentComplete: "number",
    title: "string",
    detail: "string",
    onClose: "() => void",
};

const propTypes = {
    ...PropTypes.spsGlobalPropTypes,
    percentComplete: PropTypes.number,
    title: PropTypes.string,
    detail: PropTypes.string,
    onClose: PropTypes.fun<() => void>(),
};

export type SpsProgressBarProps = PropTypes.InferTS<typeof propTypes, HTMLDivElement>;

export function SpsProgressBar(props: SpsProgressBarProps) {
    const {
        children,
        className,
        detail,
        onClose,
        percentComplete,
        title,
        "data-testid": testId,
        unsafelyReplaceClassName,
        ...rest
    } = props;

    const { t } = React.useContext(I18nContext);

    const classes = clsx(
        unsafelyReplaceClassName || "sps-progress-bar",
        percentComplete === 1 && "sps-progress-bar--complete",
        className
    );

    return (
        <div className={classes} {...rest}>
            <div className="sps-progress-bar__content">
                {title && <div className="sps-progress-bar__heading">
                    <div className="sps-progress-bar__title">{title}</div>
                    <div className="sps-progress-bar__percentage">{Math.floor(percentComplete * 100)}%</div>
                </div>}
                <div className="sps-progress-bar__bar-background">
                    <div
                        className="sps-progress-bar__bar-progress"
                        style={{
                            width: `${percentComplete * 100}%`,
                        }}
                    />
                </div>
                {detail && <div className="sps-progress-bar__detail">{detail}</div>}
            </div>
            {onClose && <div className="sps-progress-bar__close-button">
                <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.X}
                    onClick={onClose}
                    title={t("design-system:progressBar.closeButtonTitle")}
                />
            </div>}
        </div>
    );
}

Object.assign(SpsProgressBar, {
    props: propsDoc,
    propTypes,
    displayName: "SpsProgressBar"
});
